export * from './lib/pages/protection-details/protection-details.component';
export * from './lib/us-registration-feature-protection-details.routes';
